import { FC } from 'react'
import { CreditCardPanePreset } from 'components/features/creditCard/creditCardPanes/CreditCardPanePreset'
import { KillAllPanesButton } from 'components/features/pfm/Button/FloatingPaneButtons'
import { CardTerms } from 'components/features/creditCard/creditCardPage/CardTermsPage/CardTermsPage'

const CardTermsPane: FC<{}> = () => {
  return (
    <CreditCardPanePreset
      title='Terms &amp; Conditions'
      cardLayout
      primaryButton={ <KillAllPanesButton text='Close' /> }
      tertiaryButton={ null }
      withStaticFooter={ false }
    >
      <CardTerms small />
    </CreditCardPanePreset>
  )
}

export default CardTermsPane
